import { render, staticRenderFns } from "./prezzo.vue?vue&type=template&id=7bb1417d&scoped=true&"
import script from "./prezzo.vue?vue&type=script&lang=js&"
export * from "./prezzo.vue?vue&type=script&lang=js&"
import style0 from "./prezzo.vue?vue&type=style&index=0&id=7bb1417d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb1417d",
  null
  
)

export default component.exports